import { apiMapper } from "./ApiMapper";

const ConfigAPI = {
  GET_JSON_CONFIG: (axiosPrivate, fileName) => {
    return axiosPrivate.get(
      `${apiMapper.config.getJsonConfig}?file_name=${fileName}`
    );
  }
};

export default ConfigAPI;
